class SessionDB {
  static getAccessToken(): string | null {
    try {
      return localStorage.getItem('token');
    } catch (e) {
      return null;
    }
  }

  static setAccessToken(token: string | null) {
    try {
      if (token === null) localStorage.removeItem('token');
      else localStorage.setItem('token', token);
    } catch (e) {
      // ignore
    }
  }

  static getRefreshToken(): string | null {
    try {
      return localStorage.getItem('refresh_token');
    } catch (e) {
      return null;
    }
  }

  static setRefreshToken(token: string | null) {
    try {
      if (token === null) localStorage.removeItem('refresh_token');
      else localStorage.setItem('refresh_token', token);
    } catch (e) {
      // ignore
    }
  }
}

export default SessionDB;